import script from "./AiSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./AiSearch.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__